var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21a10.5 10.5 0 110-21 10.5 10.5 0 010 21zm1.12-10.52l4.16-4.14-1.27-1.29-4.04 4.03-3.91-4.03-1.23 1.29 4.01 4.14-4.01 4.14 1.23 1.29 3.9-4.03 4.05 4.02 1.27-1.28z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--error-030eed5a2e1919cda8cde3d2a8b5e273.svg";
export { SvgIconCircleError as Component };